import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Enquiry, EnquiryHeaderItem } from 'src/app/shared/models/data/enquiry.model';
import { ItemParametersValues } from 'src/app/shared/models/data/itemParametersValues.model';
import { ItemsFromXlsx } from 'src/app/shared/models/data/itemsFromXlsx.model';
import { Material } from 'src/app/shared/models/data/materials.model';
import { RoundDigit } from 'src/app/shared/models/data/roundDigit.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';

@Component({
  selector: 'app-modal-editinplace',
  templateUrl: './modal-editinplace.component.html',
  styleUrls: ['./modal-editinplace.component.scss']
})
export class ModalEditinplaceComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isMobile: boolean = false;
  @Input() theme: string = 'silver';
  @Input() dataSet: EnquiryHeaderItem[] = new Array();
  @Input() columnsToHide: string[] = new Array();
  @Input() columnsToShow: string[] = new Array();
  @Input() dateFormat: string = "";
  @Input() dateTimeFormat: string = "";
  @Input() columnsRequired: string[] = new Array();
  @Input() columnsSelect: string[] = new Array();
  @Input() columnsBoolean: string[] = new Array();
  @Input() itemsFromXlsx?: ItemsFromXlsx;
  @Input() roundDigitsForEditInPlace: RoundDigit[] = new Array();
  @Input() enquiryNo!: string;
  @Input() enquiry!: Enquiry;
  @Input() materials: Material[] = new Array();

  @Output() closeEditInPlace: EventEmitter<any> = new EventEmitter();
  @Output() changedEditInPlace: EventEmitter<EnquiryHeaderItem[]> = new EventEmitter();
  @Output() deleteItemsEditInPlace: EventEmitter<string[]> = new EventEmitter();
  @Output() gridReady: EventEmitter<void> = new EventEmitter();

  itemParameterValues: ItemParametersValues = new ItemParametersValues();
  items: EnquiryHeaderItem[] = new Array();
  columnsNotEditable: string[] = ['itemNo'];
  formIsValid: boolean = true;
  itemsToDelete: string[] = new Array();
  isLoading: boolean = false;
  isInEdit: boolean = false;
  showSettings: boolean = false;
  subscriptions: Subscription = new Subscription();

  constructor(private translate: TranslateService, private backendService: BackendService, private teiasoftLoader: TeiasoftLoaderService) { }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.getItemParametersValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["itemParameterValues"]) {
      this.itemParameterValues = changes["itemParameterValues"].currentValue;
    }

    if (changes && changes["dateFormat"]) {
      this.dateFormat = changes["dateFormat"].currentValue;
    }

    if (changes && changes["dateTimeFormat"]) {
      this.dateTimeFormat = changes["dateTimeFormat"].currentValue;
    }

    if (changes && changes["columnsRequired"]) {
      this.columnsRequired = new Array();
      this.columnsRequired = changes["columnsRequired"].currentValue;
    }

    if (changes && changes["roundDigitsForEditInPlace"]) {
      this.roundDigitsForEditInPlace = new Array();
      this.roundDigitsForEditInPlace = changes["roundDigitsForEditInPlace"].currentValue;
    }

    if (changes && changes["columnsSelect"]) {
      this.columnsSelect = new Array();
      this.columnsSelect = changes["columnsSelect"].currentValue;
    }

    if (changes && changes["columnsToHide"]) {
      this.columnsToHide = new Array();
      this.columnsToHide = changes["columnsToHide"].currentValue;
      this.columnsToHide.push("attachments");
      this.columnsToHide.push("marketingGrade");
      this.columnsToHide.push("idrIssued");
      this.columnsToHide.push("itrIssued");
      this.columnsToHide.push("icrIssued");
      this.columnsToHide.push("costsStatus");
      this.columnsToHide.push("deliveryStatus");
      this.columnsToHide.push("feasibilityStatus");
      this.columnsToHide.push("totalWeight");

      // MQF-412
      this.columnsToHide.push("WeightPerLength");
      this.columnsToHide.push("FeasibilityInfo");
      this.columnsToHide.push("CostsUom");
      this.columnsToHide.push("fullCost");
      this.columnsToHide.push("AlloySurchargeValue");
      this.columnsToHide.push("ExtraCosts");
      this.columnsToHide.push("MinimumPrice");
      this.columnsToHide.push("RecommendedPrice");
      this.columnsToHide.push("FinalPrice");
      this.columnsToHide.push("IsFinalPriceManuallyChanged");
      this.columnsToHide.push("CostsSourceDescription");
      this.columnsToHide.push("CostsSourceCostingToolVersionId");
      this.columnsToHide.push("CostsSourceCostingToolRecordId");


      /* this.columnsToHide.push("");
      this.columnsToHide.push(""); */
    }

    if (changes && changes["dataSet"] && changes["dataSet"].currentValue.length > 0) {
      this.dataSet = new Array();
      this.dataSet = JSON.parse(JSON.stringify(changes["dataSet"].currentValue));
    }

    if (changes && changes["itemsFromXlsx"] && changes["itemsFromXlsx"].currentValue != undefined) {
      this.itemsFromXlsx = new ItemsFromXlsx();
      this.itemsFromXlsx = JSON.parse(JSON.stringify(changes["itemsFromXlsx"].currentValue));
    }
  }

  getItemParametersValues() {
    this.isLoading = true;
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getItemParametersValues().subscribe(res => {
      this.itemParameterValues = new ItemParametersValues();
      this.itemParameterValues = res;
      this.isLoading = false;
      if (!this.shouldWaitForDatasheetGridReady()) {
        this.teiasoftLoader.stop();
      }
    }, error => {
      console.error('Error loading item parameters', error);
      this.isLoading = false;
      this.teiasoftLoader.stop();
    }));
  }

  onGridReady(): void {
    this.gridReady.emit();
  }

  private shouldWaitForDatasheetGridReady(): boolean {
    return !!this.itemsFromXlsx?.items?.length;
  }


  /* EVENTS */
  onCloseModalClick() {
    this.items = new Array();
    this.dataSet = new Array();
    this.closeEditInPlace.emit('');
  }

  onSaveEditClick() {
    if (this.items.length > 0) {
      const toBeUpdatedItems = this.items.filter(i => !this.itemsToDelete.includes(i.itemNo!)) // exclude removed items
      this.changedEditInPlace.emit(toBeUpdatedItems);
    }
  }

  onChangedDataset(items: EnquiryHeaderItem[]) {
    this.items = new Array();
    this.items = items;
  }

  validForm(isValid: boolean) {
    this.formIsValid = isValid;
  }

  isSaveDisabled(): boolean {
    if (!this.formIsValid) return true;
    if (this.items.length == 0 && this.itemsToDelete.length == 0) return true;
    if (this.isInEdit) return true;
    return false;
    /* if (!this.formIsValid || this.items.length == 0)
      return true;
    else
      return false; */
  }

  onSetItemsToDelete(items: string[]) {
    this.itemsToDelete = new Array();
    if (items && items.length > 0) {
      this.itemsToDelete = JSON.parse(JSON.stringify(items));
    }
    if (this.itemsToDelete.length > 0) this.formIsValid = true;
  }

  setIsInEdit(evt: boolean) {
    this.isInEdit = evt;
  }

  onClickShowSettings() {
    this.showSettings = false;
    setTimeout(() => {
      this.showSettings = true;
    });
  }

}
